export default __webpack_public_path__ + "static/media/12.215b165d.webp";